// src/components/VerificationSuccessPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Verification.module.css';
import { useAuth } from '../context/AuthProvider';
import { MailCheck } from 'lucide-react';

const VerificationSuccessPage = () => {
  const { verificationEmail, currentUser, verificationSuccess } = useAuth();
  const [countdown, setCountdown] = useState(5);
  const [showLoginOptions, setShowLoginOptions] = useState(false);
  const navigate = useNavigate();
  
  // Handle countdown to show when user will be logged out
  useEffect(() => {
    if (countdown > 0 && !showLoginOptions) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && !showLoginOptions) {
      setShowLoginOptions(true);
    }
  }, [countdown, showLoginOptions]);
  
  // Check if user is still logged in (should be logged out after 5 seconds)
  useEffect(() => {
    if (!currentUser && countdown === 0) {
      setShowLoginOptions(true);
    }
  }, [currentUser, countdown]);
  
  const handleReturnToLogin = () => {
    navigate('/');
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.iconCircle}>
        <MailCheck size={40} color="#3b8b16b9" strokeWidth={1.5} />
      </div>
      
      <h3 className={styles.title}>Verification Email Sent!</h3>
      
      <p className={styles.text}>
        We've sent a verification email to <span className={styles.highlight}>{verificationEmail}</span>.</p>
        
      
      {!showLoginOptions ? (
        <>
          <p className={styles.text}>
            You will be automatically redirected to the login page in 
            <span className={styles.countdown}> {countdown} </span> 
            seconds...
          </p>
          
          <p className={styles.warning}>
            Remember to check your spam or junk folder if you don't see the email.
          </p>
        </>
      ) : (
        <>
          <div className={styles.instructions}>
            <p className={styles.text}>
                Please follow these steps:
            </p>
            <ol>
              <li>Check your email inbox for the verification link</li>
              <li>Click the link in the email to verify your account</li>
              <li>Return to linkist.se and sign in with your credentials</li>
            </ol>
          </div>
          
          <p className={styles.warning}>
            If you don't receive the email, you can request another verification on the next page.
          </p>
          
          <div className={styles.buttons}>
            <button 
              className={styles.button}
              onClick={handleReturnToLogin}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default VerificationSuccessPage;